<!-- Truncated display-->
<div class="highlighted-topline highlighted-topline--preferred-language"
     *ngIf="truncate && topline?.appliedToplineValue">
  <strong class="color--gray--005 txt-fw-500"
          [matTooltip]="fullLangText?.textContent || ''"
          [attr.title]="fullLangText?.textContent || ''">
    <app-language-list-summary [languages]="languagesSortedTruncated"></app-language-list-summary>
  </strong>
  <!-- Hidden full list used to generate tooltip/title text -->
  <span #fullLangText aria-hidden="true" style="display: none;">
    <app-language-list-summary [languages]="languagesSortedAll"></app-language-list-summary>
  </span>
</div>

<div *ngIf="!truncate"
     class="toplines__pair toplines__pair--preferred-language col__ flexAlign--baseline"
     [ngClass]="{'toplines__pair--empty':!topline?.appliedToplineValue?.entityLanguages || topline?.appliedToplineValue?.entityLanguages.length === 0}">

  <div class="pair__icon">
    <i class="fal fa-fw fa-language"
       matTooltip="Languages"></i>
  </div>

  <div class="pair__content truncate">
    <span class="pair__label">Languages</span>
    <span *ngIf="!topline?.appliedToplineValue?.entityLanguages || topline?.appliedToplineValue?.entityLanguages.length === 0"
          (click)="onAddClicked()"
          class="pair__link link link--noline"
          data-test-id="toplineAddLanguagesLink">Add Languages</span>
    <app-language-list-summary [languages]="languagesSortedAll"></app-language-list-summary>
  </div>
</div>
